import { partyIndexes, partyColors, partyColorsArray } from './ApiUtils';

export const mapOption = {
    visualMap: {
      left: 'left',
      show: false,
      min: 1,
      max: partyColorsArray.length,
      inRange: {      
        color: partyColorsArray
      },
      text: ['High', 'Low'],
      calculable: true
    },
    title: {
    //   text: 'VOTEism Poll Prediction (2023)',
      // subtext: 'Data from www.census.gov',
      // sublink: 'http://www.census.gov/popest/data/datasets.html',
      left: 'center'
    },
    toolbox: {
      show: true,
      //orient: 'vertical',
      left: 'right',
      top: 'top',
      feature: {
      //   dataView: { readOnly: false },
        restore: {},
      //   saveAsImage: {}
      }
    }
};

export const deepCopyArrayObject = (arrayOfObjects) => {
    return arrayOfObjects.map(a => {return {...a}});
}

export const partyListWithoutGroups = (parties, group1List, group2List) => {
    let finalPartyList = []
    for(let k=0;k<parties.length;k++) {
        let tempObj = parties[k];
        let partyIndex = group1List.findIndex(o => o.partyId == tempObj.partyId);
        if(partyIndex>=0) {
            console.log('party present in group1');
        } else {
            let partyIndex2 = group2List.findIndex(o => o.partyId == tempObj.partyId);
            if(partyIndex2>=0) {
                console.log('party present in group2');
            } else {
                finalPartyList.push(tempObj);
            }
        }
    }
    return finalPartyList;
}
export const calculateLeads = (props, group1List, group2List, allPartyList) => {
    if(group1List.length>=1||group2List.length>=1) {
        let { currentState, stateResults, stateIndex } = props;
        console.log('allPartyList=',allPartyList);
        // let tempPartiesList = [];
        // for(let i=0;i<allPartyList.length;i++) {
        //     tempPartiesList.push({ partyId: allPartyList[i].partyId, mlaLeads: 0, mpLeads: 0 });
        // }    
        // console.log('tempPartiesList=',tempPartiesList);
        if(stateIndex==0) {
            let { mpLeadsGroup1, mpLeadsGroup2, newPartyList } = getIndiaLeads(stateResults, group1List,
                group2List, allPartyList);
            let finalPartyList = partyListWithoutGroups(newPartyList, group1List, group2List);
            return { mlaLeadsGroup1: 0, mlaLeadsGroup2: 0, mpLeadsGroup1: mpLeadsGroup1,
                mpLeadsGroup2: mpLeadsGroup2, parties: finalPartyList };
        }
        console.log('currentState=',currentState,' stateResults=',stateResults);
        console.log('group1List=',group1List,' group2List=',group2List);
        let { mlaData, mpData } = stateResults[currentState];
        let tempObjMLA = getMpMLALeads(mlaData.entityWise, false, group1List, group2List,
            allPartyList);
        let { group1Leads, group2Leads, parties } = getMpMLALeads(mpData.entityWise, true, group1List,
            group2List, tempObjMLA.parties);
        let finalPartyList = partyListWithoutGroups(parties, group1List, group2List);
        return { mlaLeadsGroup1: tempObjMLA.group1Leads, mlaLeadsGroup2: tempObjMLA.group2Leads,
            mpLeadsGroup1: group1Leads, mpLeadsGroup2: group2Leads, parties: finalPartyList };
    }
    return { mlaLeadsGroup1: 0, mlaLeadsGroup2: 0, mpLeadsGroup1: 0, mpLeadsGroup2: 0, parties: allPartyList };
}

const getMpMLALeads = (entityWiseData, isMP, group1List, group2List, allPartyList) => {
    let group1Leads = 0, group2Leads = 0;
    let tempPartyList = deepCopyArrayObject(allPartyList);
    console.log('tempPartyList1=',tempPartyList);
    Object.keys(entityWiseData).map(constiName => {
        // console.log('constiName=', constiName);
        let group1ConstiVoteCount = 0, group2ConstiVoteCount = 0;
        let maxPartyCount = 0, maxPartyId = '', isMaxInGroups = false;
        let constiData = entityWiseData[constiName];
        let sortedParties = Object.keys(constiData).sort();
        sortedParties.map(partyID => {
            // console.log('partyID=', partyID);
            if(maxPartyCount<constiData[partyID].voteCount) {
                maxPartyCount = constiData[partyID].voteCount;
                maxPartyId = partyID;
            }
        });
        // console.log('constiData=',constiData);
        group1List.forEach(element => {
            // console.log('group1 element=',element);
            let { partyId } = element;
            if(constiData[partyId]) {
                group1ConstiVoteCount += constiData[partyId].voteCount;
            }
            if(maxPartyId==partyId) {
                isMaxInGroups = true;
            }
        });
        group2List.forEach(element => {
            // console.log('group2 element=',element);
            let { partyId } = element;
            if(constiData[partyId]) {
                group2ConstiVoteCount += constiData[partyId].voteCount;
            }
            if(maxPartyId==partyId) {
                isMaxInGroups = true;
            }
        });
        // let group1MorethanGroup2 = isGroup1 ? group1ConstiVoteCount>=group2ConstiVoteCount
        //     : group1ConstiVoteCount>group2ConstiVoteCount;
        console.log('maxPartyId=',maxPartyId,' isMaxInGroups=',isMaxInGroups);
        if(group1ConstiVoteCount>=group2ConstiVoteCount&&group1ConstiVoteCount>=maxPartyCount) {
            group1Leads++;
        } else if(group2ConstiVoteCount>=maxPartyCount) {
            group2Leads++;
        } else if(tempPartyList) {
            // let partyIndex = tempPartyList.findIndex(o => o.partyId == maxPartyId);
            // console.log('partyIndex=',partyIndex);
            // if(partyIndex>=0) {
            //     let tempPartyObj = tempPartyList[partyIndex];
            //     if(isMP) {
            //         tempPartyObj['mpLeads']++;
            //     } else {
            //         tempPartyObj['mlaLeads']++;
            //     }
            //     tempPartyList[partyIndex] = tempPartyObj;
            // }
        }
        console.log('isMP=',isMP,' constiName=',constiName,' maxPartyCount=', maxPartyCount,
        ' group1ConstiVoteCount=',group1ConstiVoteCount,' group2ConstiVoteCount=',group2ConstiVoteCount,
        ' group1Leads=',group1Leads,' group2Leads=',group2Leads);
    });
    if(group1List.length==1&&group2List.length<2) {
        let { mpLeads, mlaLeads } = group1List[0];
        if(isMP) { group1Leads = mpLeads }
        else { group1Leads = mlaLeads }
    }
    if(group2List.length==1&&group1List.length<2) {
        let { mpLeads, mlaLeads } = group2List[0];
        if(isMP) { group2Leads = mpLeads }
        else { group2Leads = mlaLeads }
    }
    console.log('group1Leads=',group1Leads,' group2Leads=',group2Leads,' tempPartyList3=',tempPartyList);
    return { group1Leads: group1Leads, group2Leads: group2Leads, parties: tempPartyList };
}

const getIndiaLeads = (stateResults, group1List, group2List, newPartyList) => {
    let mpLeadsGroup1 = 0, mpLeadsGroup2 = 0, tempGroup1Count = 0, tempGroup2Count = 0;
    Object.keys(stateResults).map(stateKey => {
        if(stateKey!='leads') {
            // console.log('stateKey=',stateKey);
            let stateMPData = stateResults[stateKey].mpData;
            let { group1Leads, group2Leads, parties } = getMpMLALeads(stateMPData.entityWise, true,
                    group1List, group2List, newPartyList);
            newPartyList = parties;
            if(group1List.length==1&&group1Leads>0) {
                tempGroup1Count = group1Leads;
            }
            if(group2List.length==1&&group2Leads>0) {
                tempGroup2Count = group2Leads;
            }
            mpLeadsGroup1 += group1Leads;
            mpLeadsGroup2 += group2Leads;
            console.log('stateKey=',stateKey,' stateLeadGroup1=',group1Leads,' mpLeadsGroup1=',mpLeadsGroup1,
            ' stateLeadGroup2=',group2Leads,' mpLeadsGroup2=',mpLeadsGroup2);
            console.log('newPartyList=',newPartyList);
        }
    });
    if(group1List.length==1&&group2List.length<2) {
        mpLeadsGroup1 = tempGroup1Count;
    }
    if(group2List.length==1&&group1List.length<2) {
        mpLeadsGroup2 = tempGroup2Count;
    }
    console.log('total mpLeadsGroup1=',mpLeadsGroup1,' mpLeadsGroup2=',mpLeadsGroup2);
    return { mpLeadsGroup1, mpLeadsGroup2, newPartyList };
}

export const getGroupedTableRows = (currentState, formattedRows, formattedColumns, isMP) => {
    try {
        let storedStates = JSON.parse(localStorage.getItem('storedStates'));
        let { group2Array, group1Array } = storedStates[currentState];
        let tempRows = deepCopyArrayObject(formattedRows);
        let currentLength = tempRows.length;
        let newItem1 = { key: currentLength, Party: 'Group - A' };
        let newItem2 = { key: currentLength+1, Party: 'Group - B' };
        let childenArray1 = [], childenArray2 = [];
        group1Array.forEach(element => {
            console.log('element=',element,' tempRows=',tempRows);
            let objIndex = tempRows.findIndex(item => item.Party==element.partyId);
            let obj = tempRows[objIndex];
            let newChild = {...obj, key: 'groupA'+obj.key };
            console.log('newChild=',newChild);
            childenArray1.push(newChild);
            tempRows.splice(objIndex, 1);

        });
        group2Array.forEach(element => {
            console.log('element=',element);
            let objIndex = tempRows.findIndex(item => item.Party==element.partyId);
            let obj = tempRows[objIndex];
            let newChild = {...obj, key: 'groupA'+obj.key };
            console.log('newChild=',newChild);
            childenArray2.push(newChild);
            tempRows.splice(objIndex, 1);
        });
        let leadCounts = {};
        for(let i=2;i<formattedColumns.length;i++) {
            let { title } = formattedColumns[i];
            let totalVotes = 0, consti1Count = 0, consti2Count = 0, maxVoteCount = 0, maxParty = '';
            childenArray1.forEach(ele => {
                let partyConstiVote = ele[title];
                if(partyConstiVote) {
                    partyConstiVote = parseInt(partyConstiVote.split('\n')[0]);
                }
                console.log('partyConstiVote=',partyConstiVote);
                consti1Count += parseInt(partyConstiVote);
            });
            consti2Count = 0;
            childenArray2.forEach(ele => {
                let partyConstiVote = ele[title];
                if(partyConstiVote) {
                    partyConstiVote = parseInt(partyConstiVote.split('\n')[0]);
                }
                console.log('partyConstiVote=',partyConstiVote);
                consti2Count += parseInt(partyConstiVote);
            });
            totalVotes = consti1Count+consti2Count;
            for(let i=0;i<tempRows.length;i++) {
                let partyConstiVote = tempRows[i][title];
                if(partyConstiVote) {
                    partyConstiVote = parseInt(partyConstiVote.split('\n')[0]);
                    totalVotes += parseInt(partyConstiVote);
                }
                console.log('partyConstiVote=',partyConstiVote);
                if(partyConstiVote>maxVoteCount) {
                    maxVoteCount = partyConstiVote;
                    maxParty = tempRows[i]['Party'];
                }
            }
            newItem1[title] = consti1Count+'\n('+(consti1Count*100/totalVotes).toFixed(2)+'%)';
            newItem2[title] = consti2Count+'\n('+(consti2Count*100/totalVotes).toFixed(2)+'%)';
            console.log('title=',title,' maxParty=',maxParty,' maxVoteCount=',maxVoteCount,
            ' totalVotes=',totalVotes, ' consti1Count=',consti1Count,' consti2Count=',consti2Count);
            if(maxVoteCount>consti1Count&&maxVoteCount>consti2Count) {
                leadCounts[maxParty] = leadCounts[maxParty] ? leadCounts[maxParty]+1 : 1;
            } else if(consti1Count>=consti2Count) {
                leadCounts['GroupA'] = leadCounts['GroupA'] ? leadCounts['GroupA']+1 : 1;
            } else {
                leadCounts['GroupB'] = leadCounts['GroupB'] ? leadCounts['GroupB']+1 : 1;
            }
            console.log('leadCounts=',leadCounts);
        }
        if(group1Array.length==1&&group2Array.length<2) {
            let { mpLeads, mlaLeads } = group1Array[0];
            if(isMP) { leadCounts['GroupA'] = mpLeads }
            else { leadCounts['GroupA'] = mlaLeads }
        }
        if(group2Array.length==1&&group1Array.length<2) {
            let { mpLeads, mlaLeads } = group2Array[0];
            if(isMP) { leadCounts['GroupB'] = mpLeads }
            else { leadCounts['GroupB'] = mlaLeads }
        }
        newItem1['children'] = childenArray1;
        newItem2['children'] = childenArray2;
        let groupRows = [];
        if(group1Array.length>0) {
            newItem1['Leads'] = leadCounts['GroupA'] ? leadCounts['GroupA'] : 0;
            groupRows.push(newItem1);
        }
        if(group2Array.length>0) {
            newItem2['Leads'] = leadCounts['GroupB'] ? leadCounts['GroupB'] : 0;
            groupRows.push(newItem2);
        }
        for(let i=0;i<tempRows.length;i++) {
            let rowData = tempRows[i];
            rowData['Leads'] = leadCounts[rowData['Party']] ? leadCounts[rowData['Party']] : 0;
        }
        let newFormatRows = [...groupRows, ...tempRows];
        console.log('newFormatRows=',newFormatRows);
        return newFormatRows;
    } catch(e) {
        console.log('error in getting grouped table rows=',e);
        return formattedRows;
    }
}

export const getIndiaGroupedTableRows = (props, currentState, formattedRows, formattedColumns) => {
    try {
        let storedStates = JSON.parse(localStorage.getItem('storedStates'));
        let { group2Array, group1Array } = storedStates[currentState];
        if(((!group1Array)||group1Array.length<1)&&((!group2Array)||group2Array.length<1)) {
            return formattedRows;
        }
        let tempRows = [...formattedRows];
        let currentLength = tempRows.length;
        let newItem1 = { key: currentLength, Party: 'Group - A' };
        let newItem2 = { key: currentLength+1, Party: 'Group - B' };
        let childenArray1 = [], childenArray2 = [], groupALeads = 0, groupBLeads = 0;
        group1Array.forEach(element => {
            console.log('element=',element,' tempRows=',tempRows);
            let objIndex = tempRows.findIndex(item => item.Party==element.partyId);
            let obj = tempRows[objIndex];
            // groupALeads += parseInt(obj.Leads);
            let newChild = {...obj, key: 'groupA'+obj.key };
            console.log('newChild=',newChild);
            childenArray1.push(newChild);
            tempRows.splice(objIndex, 1);

        });
        group2Array.forEach(element => {
            console.log('element=',element);
            let objIndex = tempRows.findIndex(item => item.Party==element.partyId);
            let obj = tempRows[objIndex];
            // groupBLeads += parseInt(obj.Leads);
            let newChild = {...obj, key: 'groupA'+obj.key };
            console.log('newChild=',newChild);
            childenArray2.push(newChild);
            tempRows.splice(objIndex, 1);
        });
        newItem1['children'] = childenArray1;
        newItem2['children'] = childenArray2;
        let newPartyList = [];
        for(let i=0;i<formattedRows.length;i++) {
            let newPartyItem = { partyId: formattedRows[i].Party, mlaLeads: 0, mpLeads: 0 }
            newPartyList.push(newPartyItem);
        }
        console.log('newPartyList=',newPartyList);
        let { mpLeadsGroup1, mpLeadsGroup2 }
            = calculateLeads(props, group1Array, group2Array, newPartyList, true);
        groupALeads = parseInt(mpLeadsGroup1);
        groupBLeads = parseInt(mpLeadsGroup2);
        let groupRows = [];
        if(group1Array.length>0) {
            newItem1['Leads'] = groupALeads;
            groupRows.push(newItem1);
        }
        if(group2Array.length>0) {
            newItem2['Leads'] = groupBLeads;
            groupRows.push(newItem2);
        }
        let newFormatRows = [...groupRows, ...tempRows];
        console.log('newFormatRows=',newFormatRows);
        return newFormatRows;
    } catch(e) {
        console.log('error in getting grouped table rows=',e);
        return formattedRows;
    }
}

// AAP - 1, AIMIM - 5, BJP - 13, BRS - 14, CPM - 21, INC - 27, NOTA - 51, TDP - 74, GROUP1 - 82, GROUP2 - 83
export const sampleVoteData = [
    { name: 'ADILABAD(ST)', value: 1 },
    { name: 'PEDDAPALLE (SC)', value: 1 },
    { name: 'KARIMNAGAR', value: 5 },
    { name: 'NIZAMABAD', value: 13 },
    { name: 'ZAHIRABAD', value: 13 },
    { name: 'MEDAK', value: 14 },
  //   { name: 'MALKAJGIRI', value: 21 },
    { name: 'SECUNDERABAD', value: 27 },
    { name: 'HYDERABAD', value: 27 },
    { name: 'CHEVELLA', value: 51 },
    { name: 'MAHBUBNAGAR', value: 51 },
    { name: 'NAGARKURNOOL(SC)', value: 74 },
    { name: 'NALGONDA', value: 74 },
    { name: 'BHONGIR', value: 82 },
    { name: 'WARANGAL(SC)', value: 82 },
    { name: 'MAHABUBABAD(ST)', value: 83 },
    { name: 'KHAMMAM', value: 83 },
];

export const mpLeadsArray = (mpMlaVotesData, group1List, group2List) => {
    let leadData = [], stateToolTip = {};

    for(let i=0;i<mpMlaVotesData.length;i++) {
        let currentObj = mpMlaVotesData[i];
        let constiName = currentObj.pc_name ? currentObj.pc_name.toUpperCase() : currentObj.ac_name;
        let leadObj = { name: constiName };
        let maxKey = '', maxValue = 0, toolTipMsg = '', sortable = [], group1Count = 0, group2Count = 0;
        Object.keys(currentObj).map(key => {
            // console.log('party Logo currentObj=',currentObj);
            let value = currentObj[key];
            if(value>maxValue) {
                maxKey = key;
                maxValue = value;
            }
            let found2 = group2List.some(el => el.partyId === key);
            if(found2) {
                group2Count+= value;
                if(group2Count>=maxValue) {
                    maxKey = 'GROUP2';
                    maxValue = group2Count;
                }
            }
            let found1 = group1List.some(el => el.partyId === key);
            if(found1) {
                group1Count+= value;
                if(group1Count>=maxValue) {
                    maxKey = 'GROUP1';
                    maxValue = group1Count;
                }
            }
            sortable.push([key, value]);
        });
        sortable.push(['GroupA', group1Count]);
        sortable.push(['GroupB', group2Count]);
        sortable.sort(function(a, b) {
            return b[1] - a[1];
        });
        // toolTipMsg += ('Group1: '+group1Count+'<br />');
        // toolTipMsg += ('Group2: '+group2Count+'<br />');
        for(let i=0;i<sortable.length;i++) {
            let currentObj = sortable[i];
            if(currentObj[0]!='ac_name'&&currentObj[0]!='pc_name') {
                toolTipMsg += (currentObj[0]+': '+currentObj[1]+'<br />');
            }
        }
        // console.log('sortable=',sortable);
        stateToolTip[constiName] = toolTipMsg;
        // console.log('constiName=',constiName,' maxKey=',maxKey,' maxValue=',maxValue);
        leadObj.value = partyIndexes[maxKey];
        leadData.push(leadObj);
    }
    console.log('leadData=',leadData);
    return {leadData, stateToolTip};
}

export const parsePartiesData = (stateData) => {
    let parsedArray = [], partyKeys = [];
    console.log('stateData=',stateData);
    Object.keys(stateData).forEach((key) => {
        let { voteCount, votePercentage } = stateData[key];
        let partyColor = partyColors[key];
        console.log('key=',key,' partyColor=',partyColor,' partyVotes=',voteCount);
        parsedArray.push({ value: voteCount, itemStyle: {color: partyColor} });
        partyKeys.push(key);
    });
    return { parsedArray, partyKeys };
}

// below function is not being used currently
export const parseChartData = (allPartyList) => {
    let mlaLeadsArray = [], mpLeadsArray = [], partyKeys = [], richDataObject = {};
    allPartyList = allPartyList.sort((a,b) => a.mlaLeads-b.mlaLeads);
    console.log('parse Chart Data allPartyList=',allPartyList);
    for(let i=0;i<allPartyList.length;i++) {
        let { partyId, mlaLeads, mpLeads } = allPartyList[i];
        mlaLeadsArray.push({ value: mlaLeads, itemStyle: {color: partyColors[partyId]} });
        mpLeadsArray.push({ value: mpLeads, itemStyle: {color: partyColors[partyId]} });
        partyKeys.push(partyId);
        // todo need to update the image url here
        richDataObject[partyId] = { height: 40, align: 'center',
        backgroundColor: { image: 'https://voteism.web.app/'+partyId+'.png' } };
    }
    return { mlaLeadsArray, mpLeadsArray, partyKeys, richDataObject };
}

export const parseBarChartData = (allPartyList, group1List, group2List, mpMla1Count, mpMla2Count, partyLogos) => {
    let barChartData = [], mpTotalLeads = 0, mlaTotalLeads = 0, maxValue = 0;
    allPartyList = allPartyList.sort((a,b) => b.mlaLeads-a.mlaLeads);
    console.log('allPartyList=',allPartyList);
    let group1MlaLead = mpMla1Count.mla, group1MpLead = mpMla1Count.mp;
    if(group1MlaLead>0||group1MpLead>0) {
        let mlaText = ' (', mpText = ' (';
        for(let i=0;i<group1List.length;i++) {
            let { partyId, mlaLeads, mpLeads } = group1List[i];
            mlaText += (i ? ' + ' : '')+partyId+'-'+mlaLeads;
            mpText += (i ? ' + ' : '')+partyId+'-'+mpLeads;
        }
        mlaText += ')'
        mpText += ')';
        barChartData.push({"party": 'GROUP1', "logo": "", "mlaLeads": group1MlaLead,
        "mpLeads": group1MpLead, "mlaText": mlaText, "mpText": mpText});
    }
    if(group1MlaLead>maxValue) { maxValue = group1MlaLead; }
    if(group1MpLead>maxValue) { maxValue = group1MpLead; }
    let { mla, mp } = mpMla2Count;
    if(mla>0||mp>0) {
        let mlaText = ' (', mpText = ' (';
        for(let i=0;i<group2List.length;i++) {
            let { partyId, mlaLeads, mpLeads } = group2List[i];
            mlaText += (i ? ' + ' : '')+partyId+'-'+mlaLeads;
            mpText += (i ? ' + ' : '')+partyId+'-'+mpLeads;
        }
        mlaText += ')'
        mpText += ')';
        barChartData.push({"party": 'GROUP2', "logo": "", "mlaLeads": mla, "mpLeads": mp,
        "mlaText": mlaText, "mpText": mpText });
    }
    if(mla>maxValue) { maxValue = mla; }
    if(mp>maxValue) { maxValue = mp; }
    for(let i=0;i<allPartyList.length;i++) {
        let { partyId, mlaLeads, mpLeads } = allPartyList[i];
        mlaTotalLeads += mlaLeads;
        if(mlaLeads>maxValue) { maxValue = mlaLeads; }
        mpTotalLeads += mpLeads;
        if(mpLeads>maxValue) { maxValue = mpLeads; }
        let partyLogo = partyLogos[partyId];
        barChartData.push({"party": partyId, "logo": partyLogo,
        "mlaLeads": mlaLeads, "mpLeads": mpLeads, "mlaText": '', "mpText": '' });
    }
    return { barChartData, mpTotalLeads, mlaTotalLeads, maxValue };
}